import Component from '../core/Component'

const defaults = {}
export const STATES = {}
export const EMITS = {}

export default class Progress extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            bar: null,
            content: null
        }

        this.progress = 0
        this.min = .4
    }

    prepare() {

    }

    //v procentech
    setProgress(progress) {
        this.progress = progress
        this.update()
    }

    setContent(text) {
        this.ref.content.innerText = text
    }

    update() {
        this.ref.bar.style.width = `${(this.min + this.progress * (1-this.min)) * 100}%`
    }
}